"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var removeInboxRuleRequest_1 = require("owa-service/lib/factory/removeInboxRuleRequest");
var removeInboxRuleOperation_1 = require("owa-service/lib/operation/removeInboxRuleOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Helper method that creates the RemoveInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return RemoveInboxRuleRequest
 */
function createRequestBody(inboxRule) {
    return removeInboxRuleRequest_1.default({ Header: ServiceRequestUtils_1.getJsonRequestHeader(), Identity: inboxRule.Identity });
}
/**
 * Remove inbox rule service
 * @param inboxRule the inbox rule
 * @return RemoveInboxRuleResponse
 */
function removeInboxRuleService(inboxRule) {
    var requestBody = createRequestBody(inboxRule);
    return removeInboxRuleOperation_1.default(requestBody);
}
exports.default = removeInboxRuleService;
//# sourceMappingURL=removeInboxRuleService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/removeInboxRuleService.js
// module id = 5172
// module chunks = 2